<div id="smart-send-map-container">
  <mgl-map
    [style]="styleUrl"
    [zoom]="[Zoom]"
    [center]="center"
    [transformRequest]="transformReq"
    class="map"
    (load)="onMapReady($event)"
    [cursorStyle]="cursorStyle"
  >
    <mgl-control>
      <div class="tw-w-[325px]">
        <!-- search input -->
        <mat-form-field
          class="select-list__search tw-w-full"
          appearance="outline"
        >
          <mat-label>{{ "common.search" | translate }}</mat-label>
          <div class="search-box tw-flex-center tw-w-full tw-relative">
            <input
              type="text"
              #searchInput
              matInput
              [formControl]="myControl"
              [matAutocomplete]="auto"
            />

            <i
              *ngIf="!loadingPublic"
              class="input-btns mdi mdi-magnify mdi-24px text-dark bg-white"
            ></i>
            <i
              *ngIf="loadingPublic"
              class="input-btns mdi mdi-sync mdi-24px mdi-spin text-dark bg-white"
            ></i>
          </div>

          <mat-autocomplete #auto="matAutocomplete" (opened)="onScrollDown()">
            <div>
              <mat-option
                (click)="getSelectedFilterPlace(option)"
                *ngFor="let option of filteredOptions;trackBy:trackByFunc; let i = index"
                [value]="option.title"
              >
                {{option.title}}
              </mat-option>
            </div>
          </mat-autocomplete>
        </mat-form-field>
      </div>
    </mgl-control>

    <mgl-control mglNavigation></mgl-control>
    <mgl-control>
      <div class="mapboxgl-ctrl-group">
        <button
          *ngIf="ShowSaveButton"
          class=""
          type="button"
          title="{{ 'common.savePolygon' | translate}}"
          aria-label="Save Polygon"
          aria-disabled="false"
          (click)="onSaveButtonClick($event)"
        >
          <i class="save-icon mdi mdi-sticker-plus"></i>
        </button>
        <button
          class=""
          type="button"
          title="{{ 'common.help' | translate}}"
          aria-label="Help"
          aria-disabled="false"
          (click)="onHelpButtonClick($event)"
        >
          <i class="help-icon mdi mdi-help-box"></i>
        </button>
      </div>
    </mgl-control>
    <mgl-geojson-source
      id="polygon-source"
      [data]="DisplayPolygon"
    ></mgl-geojson-source>
    <mgl-layer
      id="display-polygon-area"
      type="fill"
      source="polygon-source"
      [paint]="{
          'fill-color': DisplayPolygonFillColor,
          'fill-opacity' : DisplayPolygonFillOpacity
        }"
    ></mgl-layer>
  </mgl-map>
</div>
